module.exports = __webpack_public_path__ + "img/404.ff4256e7.jpg";